/**
 * FCM token localStorage helpers (shared between useFCM and AuthContext)
 */

export interface StoredTokenInfo {
  userId: number;
  token: string;
  deviceId: string;
  deviceType: 'ios' | 'android' | 'web';
  updatedAt: number;
}

const TOKEN_STORAGE_KEY_PREFIX = 'fcm_token_info';

export const getTokenStorageKey = (userId: number) =>
  `${TOKEN_STORAGE_KEY_PREFIX}_${userId}`;

export const loadStoredTokenInfo = (userId: number): StoredTokenInfo | null => {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(getTokenStorageKey(userId));
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StoredTokenInfo;
    if (
      parsed &&
      parsed.userId === userId &&
      typeof parsed.token === 'string' &&
      typeof parsed.deviceId === 'string' &&
      typeof parsed.deviceType === 'string'
    ) {
      return parsed;
    }
  } catch {
    // ignore
  }
  return null;
};

export const saveStoredTokenInfo = (info: StoredTokenInfo): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getTokenStorageKey(info.userId), JSON.stringify(info));
};

export const clearStoredTokenInfo = (userId: number): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(getTokenStorageKey(userId));
};
